module.exports = __webpack_public_path__ + "webStatic/img/miniprogram_car.788967e6.png";